import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CreateField from './CreateField';

import {
  addField,
  closeMemberGroupFieldDialog,
  formFieldChange,
} from './actions';

const mapStateToProps = state => ({
  ...state.auth.memberGroups.edit.createField,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: () =>
    dispatch(
      addField(ownProps.match.params.appname, ownProps.match.params.groupID),
    ),
  onRequestClose: () => dispatch(closeMemberGroupFieldDialog()),
  onFieldChange: (field, value) => dispatch(formFieldChange(field, value)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateField),
);
